import Vue from "vue";
import Vuex from "vuex";

import form from "./modules/form";
import auth from "./modules/auth";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    form,
    auth
  }
});
